import jwtDecode from 'jwt-decode';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { IThisToken } from '../types/Types';

export const ProtectedRoute: React.FC<{ children: JSX.Element }> = ({ children }) => {

    const navigate = useNavigate();
    const [loaded, setLoaded] = useState<Boolean>(false);

    useEffect(() => {
        try {
            const token = localStorage.getItem('token');
            if (token !== null) {
                const thisToken: IThisToken = jwtDecode(token);
                if (thisToken.roles.indexOf("office") === -1)
                    navigate({
                        pathname: '/'
                    });
            }
        } catch (e) {
            navigate({
                pathname: '/'
            });
        }
        setLoaded(true);
    }, []);

    return (
        <>
            {(loaded) ? children : ""}
        </>
    );
};

